<template>
  <div class="spinner-border" role="status">
     <span class="sr-only">Loading...</span>
   </div>
</template>

<style scoped>
  .loading-container {
    /* display: flex;
    justify-content: center;
    align-items: center; */
  }
</style>